<soft-list-page [resource]="timeReportsService" (itemClick)="onItemClick($event)">
  <soft-page-header>
    <!--TODO-->
    <soft-meta-query-bar
      [metaForm]="queryMeta"
      [query]="query()"
      (queryChange)="setQuery($event)"
    ></soft-meta-query-bar>
  </soft-page-header>

  <ng-template let-item="item">
    <soft-dynamic-object
      [definition]="$any(definition())"
      [value]="item"
    ></soft-dynamic-object>
    <!--div class="soft-card rounded-md">
      <ng-container
        *ngComponentOutlet="timeReportComponent; inputs: { value: item, meta: meta }"
      ></ng-container>
    </div-->
  </ng-template>
  <soft-page-summary>
    <hr class="mt-3 mb-2" />
    @for (sum of sums(); track sum) {
      <div class="flex flex-row justify-between items-center flex-nowrap">
        <strong class="ml-1">Gesamt</strong>
        <strong>{{ sum.duration | format: 'DURATION.DEFAULT' }}</strong>
      </div>
    }
    @if (sums().length === 0) {
      <p>Keine Stunden Gesamt vorhanden</p>
    }
  </soft-page-summary>
</soft-list-page>
